import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  subscription = 'PricingSubscriptionAntivirus',
  payment = 'PricingPaymentAntivirus',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/security/',
    alias: ['/:lang?/pricing/antivirus/'],
    component: () => import('@/modules/antivirus/layout/LayoutPage.vue'),
    children: [
      {
        path: '',
        name: MODULE_ROUTE.subscription,
        component: () =>
          import('@/modules/antivirus/pages/subscription/PageSubscription.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/antivirus/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
